import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCompanyData, getProviderBiddings } from 'store/modules/market_store/actions';
import CompanyDetails from 'components/molecules/company_details';
import AiManagementDrawer from 'components/molecules/ai_management_drawer';
import { Content } from './styles';

interface AiManagementCompanyDrawerProps {
  cnpj: string;
  name: string | null;
  onClose: () => void;
}

const AiManagementCompanyDrawer: React.FC<AiManagementCompanyDrawerProps> = ({
  cnpj,
  name,
  onClose,
}) => {
  const dispatch = useDispatch();
  const [currentPageBidding, setCurrentPageBidding] = useState(1);

  useEffect(() => {
    dispatch(getCompanyData(cnpj));
    setCurrentPageBidding(1);
  }, [cnpj]);

  useEffect(() => {
    dispatch(getProviderBiddings(cnpj, currentPageBidding));
  }, [cnpj, currentPageBidding]);

  return (
    <AiManagementDrawer
      title={name ?? 'Concorrente'}
      variant="side"
      bodyClassName="py-3"
      onClose={onClose}
    >
      <Content>
        <CompanyDetails
          setCurrentPageBidding={setCurrentPageBidding}
          currentPageBidding={currentPageBidding}
        />
      </Content>
    </AiManagementDrawer>
  );
};

export default AiManagementCompanyDrawer;
